export default __webpack_public_path__ + "static/media/avatar-users.df0fb35f.png";